import ResetPassword from "./ResetPassword.react"

export const DefaultComponent = ResetPassword
export { ResetPassword }
